import { useEffect, useState } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import { DictTypes } from '@/constants';
import { autoCreditApi } from '@/integrations/app.api/auto-credit.api';
import { handleError } from '@/services/handleError';
import { useAppSelector } from '@/store';
import type { IUsedCar } from '@/types/model.type';

import type { CreateAutoCreditProps } from '../../../types/form-types';

const useUsedCars = () => {
  const { dicts } = useAppSelector((state) => state.dict);

  const { control } = useFormContext<CreateAutoCreditProps>();
  const [autoType, dealer] = useWatch({
    control,
    name: ['autoType', 'dealer']
  });
  const isUsedCar = autoType === '2';
  const dealerUuid = dicts?.[DictTypes.Dealers]?.getBy.code[dealer]?.uuid;

  const [usedCarsOptions, setUsedCarsOptions] = useState<
    (IUsedCar & { value: string; label: string })[]
  >([]);

  useEffect(() => {
    if (!isUsedCar || !dealerUuid) return;
    const controller = new AbortController();
    (async () => {
      try {
        const response = await autoCreditApi.getUsedCarsByDealer(
          dealerUuid,
          controller.signal
        );
        setUsedCarsOptions(
          response.map((item) => {
            let label = `${item.brand_name}, ${item.model_name}`;
            if (item.vin_code) {
              label += ` (${item.vin_code})`;
            }
            return {
              ...item,
              value: item.uuid,
              label
            };
          })
        );
      } catch (error) {
        handleError(error);
      }
    })();
    return () => {
      // Отменяем запрос для предыдущего дилера и сбрасываем его список
      controller.abort();
      setUsedCarsOptions([]);
    };
  }, [isUsedCar, dealerUuid]);

  return { usedCarsOptions: isUsedCar ? usedCarsOptions : [] };
};

export default useUsedCars;
